<template>
    <div class="codics-aonaer-info-sys-one-stop-body">
        <WebHeader></WebHeader>
        <div class="codics-aonaer-info-sys-one-stop-box">
            <div class="codics-aonaer-info-sys-one-stop-container">
                <h2 class="codics-aonaer-info-sys-one-stop-title">飞斯智能装备有限公司</h2>
                <span style="line-height:2;">飞斯智能装备有限公司 (FIS)
                    致力于为食品行业提供世界领先的定制化解决方案，尤其以肉类加工行业全价值链的高质量管理化系统而闻名，从肉类胴体等级化筛分到屠宰线，去骨和分割的可追溯化系统，以及产线智能化控制到物流和包装系统整合等。</span><br>
                <img src="https://cdn.bosscaigou.com/huayuan/img/yasuo_fs_zn.webp"
                    class="codics-aonaer-info-sys-one-stop-img">
            </div>
        </div>
        <WebFooter></WebFooter>
    </div>
</template>

<script>
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
export default {
    data() {
    },
    mounted() {

    },
    methods: {

    },
    components: {
        WebHeader,
        WebFooter
    }
}
</script>

<style>
.codics-aonaer-info-sys-one-stop-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
}

.codics-aonaer-info-sys-one-stop-box {
    height: fit-content;
    min-height: calc(100vh - 354px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-one-stop-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 5px;
    margin-top: 100px;
}

.codics-aonaer-info-sys-one-stop-title {
    height: 50px;
    width: 100%;
    position: relative;
    float: left;
    font-size: 30px;
    font-weight: 600;
    color: #ea5b18;
    line-height: 80px;
    text-align: center
}

.codics-aonaer-info-sys-one-stop-tag {
    height: 30px;
    width: 100%;
    position: relative;
    float: left;
    font-size: 23px;
    font-weight: 600;
    color: #333;
    line-height: 25px;
    text-align: center
}

.codics-aonaer-info-sys-one-stop-img {
    height: 380px;
    width: 100%;
    position: relative;
    float: left;
    object-fit: fill;
    margin-top: 20px;
    margin-bottom: 50px;
}

.codics-aonaer-info-sys-one-stop-btn {
    height: 50px;
    width: 150px;
    position: relative;
    float: left;
    background: #FFF;
    border: 1px solid #ea5b18;
    color: #ea5b18;
    font-size: 16px;
    line-height: 50px;
    text-align: center;
    border-radius: 25px;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 70px;
    margin-bottom: 100px;
    transition: .3s;
    cursor: pointer;
    text-decoration: none;
}

.codics-aonaer-info-sys-one-stop-btn:hover {
    background: #ea5b18;
    color: #FFF;
}
</style>